
import {
    OBSERVACION_USER_ERROR,
    OBSERVACION_USER_LOADED,
    OBSERVACION_USER_LOADING,

    OBSERVACION_HOME_ERROR,
    OBSERVACION_HOME_LOADED,
    OBSERVACION_HOME_LOADING,

    OBSERVACION_HOMEMAPA_ERROR,
    OBSERVACION_HOMEMAPA_LOADED,
    OBSERVACION_HOMEMAPA_LOADING,

    OBSERVACION_EXPLORAR_ERROR,
    OBSERVACION_EXPLORAR_LOADED,
    OBSERVACION_EXPLORAR_LOADING,
    OBSERVACION_EXPLORAR_MAPA_LOADED,

    OBSERVACION_INDIVIDUAL_EXPLORAR_ERROR,
    OBSERVACION_INDIVIDUAL_EXPLORAR_LOADED,
    OBSERVACION_INDIVIDUAL_EXPLORAR_LOADING,

    COMENTARIO_OBSERVACION_LOADING,
    COMENTARIO_OBSERVACION_LOADED,
    COMENTARIO_OBSERVACION_ERROR,

    IDENTIFICACION_OBSERVACION_LOADING,
    IDENTIFICACION_OBSERVACION_LOADED,
    IDENTIFICACION_OBSERVACION_ERROR,

    TAXO_OBSERVACION_LOADING,
    TAXO_OBSERVACION_LOADED,
    TAXO_OBSERVACION_ERROR,

    CREAR_OBSERVACION_LOADING,
    CREAR_OBSERVACION_LOADED,
    CREAR_OBSERVACION_ERROR,
    RESET_OBSERVACION_STATE,
    RESET_EDITOBSERVACION_STATE,

    OBSERVACION_INDI_LOADING,
    OBSERVACION_INDI_LOADED,
    OBSERVACION_INDI_ERROR,
    OBSERVACION_MAPA_LOADED,

    OBSERVACION_PROYECTO_ERROR,
    OBSERVACION_PROYECTO_LOADED,
    OBSERVACION_PROYECTO_LOADING,
    OBSERVACION_PROYECTO_MAPA_LOADED,

    EDITAR_OBSERVACION_LOADING,
    EDITAR_OBSERVACION_LOADED,
    EDITAR_OBSERVACION_ERROR,

    DELETE_OBSERVACION_LOADING,
    DELETE_OBSERVACION_LOADED,
    DELETE_OBSERVACION_ERROR,

    OBSERVACION_DEX_LOADING,
    OBSERVACION_DEX_LOADED,
    OBSERVACION_DEX_ERROR,

  } from './../../types/observacion';

const INITIAL_STATE = {
    isLoading: false,
    isLoaded: false,
    observacion_user: [],

    obsDeleteError: '', 
    obsDeleteLoading: false, 
    obsDeleteLoaded: false,

    obseditLoading: false,
    obseditLoaded: false,
    obsedit: [],
    obseditError: '',

    obsindiLoading: false,
    obsindiLodaded: false,
    obsindi: [],
    obsindiError: '',
    obsindimapa: [],

    crearobsLoading: false,
    crearobsLodaded: false,
    crearobs: [],
    crearobsError: '',

    taxo:[],
    taxoLoading: false,
    taxoLoaded: false,
    taxoError: '',

    identificacion:[],
    idLoading:false,
    idLoaded:false,
    idError:'',

    comentario:[],
    comentarioLoading:false,
    comentarioLoaded:false,
    comentarioError:'',

    explorar:[],
    explorarmapa:[],
    exploloading:false,
    exploloaded:false,
    exploerror:'',

    obspro:[],
    obspromapa:[],
    obsproloading:false,
    obsproloaded:false,
    obsproerror:'',

    obs:[],
    obsLoading:false,
    obsLodaded:false,
    obsError:'',

    puntos:[],
    loading:false,
    error: '',

    carusel:[],
    loading2:false,
    error2: '',

    obsdexLoading: false,
    obsdex: [],
    obsdexLodaded:false,
    obsdexError: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case DELETE_OBSERVACION_LOADING:
            return {
                ... state,
                obsDeleteError: '', 
                obsDeleteLoading: true, 
                obsDeleteLoaded: false,
            }
        case DELETE_OBSERVACION_LOADED:
            return {
                ...state,
                obsDeleteLoading: false,
                obsDeleteLoaded:true,
                obsDeleteError: ''
            };
        case DELETE_OBSERVACION_ERROR:
            return {
                ...state,
                obsDeleteLoading: false,
                obsDeleteLoaded:false,
                obsDeleteError: action.payload
            }

        case OBSERVACION_PROYECTO_LOADING:
            return {
                ... state,
                obsproloading: true,
                obspro: [],
                obsproloaded:false,
                obsproerror: ''
            }
        case OBSERVACION_PROYECTO_LOADED:
            return {
                ...state,
                obsproloading: false,
                obspro: action.payload,
                obsproloaded:true,
                obsproerror: ''
            };

        case OBSERVACION_PROYECTO_MAPA_LOADED:
            return {
                ...state,
                obsproloading: false,
                obspromapa: action.payload,
                obsproloaded:true,
                obsproerror: ''
            };
        case OBSERVACION_PROYECTO_ERROR:
            return {
                ...state,
                obsproloading: false,
                obspro: [],
                obsproloaded:false,
                obsproerror: action.payload
            }

        case RESET_EDITOBSERVACION_STATE:
            return {
                ... state,
                obseditLoading: false,
                obseditLoaded: false,
                obsedit: [],
                obseditError: '',
            }

        case RESET_OBSERVACION_STATE:
            return INITIAL_STATE;

        case EDITAR_OBSERVACION_LOADING:
            return {
                ... state,
                obseditLoading: true,
                obsedit: [],
                obseditLoaded:false,
                obseditError: '',
            }
        case EDITAR_OBSERVACION_LOADED:
            const { proyectos_info, ...payloadWithoutProyectosInfo } = action.payload;
            return {
                ...state,
                obseditLoading: false,
                obsedit: action.payload,
                obs: {
                    ...state.obs,
                    ...action.payload,
                    Proyecto: proyectos_info || state.obs.Proyecto
                },
                obseditLoaded:true,
                obseditError: ''
            };
        case EDITAR_OBSERVACION_ERROR:
            return {
                ...state,
                obseditLoading: false,
                obsedit: [],
                obseditLoaded:false,
                obseditError: action.payload
            }

        case OBSERVACION_DEX_LOADING:
            return {
                ... state,
                obsdexLoading: true,
                obsdex: [],
                obsdexLodaded:false,
                obsdexError: '',
            }
        case OBSERVACION_DEX_LOADED:
            return {
                ...state,
                obsdexLoading: false,
                obsdex: action.payload,
                obsdexLodaded:true,
                obsdexError: ''
            };
        case OBSERVACION_DEX_ERROR:
            return {
                ...state,
                obsdexLoading: false,
                obsdex: [],
                obsdexLodaded:false,
                obsdexError: action.payload
            }

        case OBSERVACION_INDI_LOADING:
            return {
                ... state,
                obsindiLoading: true,
                obsindi: [],
                obsindiLodaded:false,
                obsindiError: '',
            }
        case OBSERVACION_INDI_LOADED:
            return {
                ...state,
                obsindiLoading: false,
                obsindi: action.payload,
                obsindiLodaded:true,
                obsindiError: ''
            };
        case OBSERVACION_MAPA_LOADED:
            return {
                ...state,
                obsindiLoading: false,
                obsindimapa: action.payload,
                obsindiLodaded:true,
                obsindiError: ''
            };
        case OBSERVACION_INDI_ERROR:
            return {
                ...state,
                obsindiLoading: false,
                obsindi: [],
                obsindiLodaded:false,
                obsindiError: action.payload
            }

        case CREAR_OBSERVACION_LOADING:
            return {
                ... state,
                crearobsLoading: true,
                crearobs: [],
                crearobsLodaded:false,
                crearobsError: '',
            }
        case CREAR_OBSERVACION_LOADED:
            return {
                ...state,
                crearobsLoading: false,
                crearobs: action.payload,
                crearobsLodaded:true,
                crearobsError: ''
            };
        case CREAR_OBSERVACION_ERROR:
            return {
                ...state,
                crearobsLoading: false,
                crearobs: [],
                crearobsLodaded:false,
                crearobsError: action.payload
            }

        case TAXO_OBSERVACION_LOADING:
            return {
                ... state,
                taxoLoading: true,
                taxo: [],
                taxoLoaded:false,
                taxoError: '',
            }
        case TAXO_OBSERVACION_LOADED:
            return {
                ...state,
                taxoLoading: false,
                taxo: action.payload,
                taxoLoaded:true,
                taxoError: ''
            };
        case TAXO_OBSERVACION_ERROR:
            return {
                ...state,
                taxoLoading: false,
                taxo: [],
                taxoLoaded:false,
                taxoError: action.payload
            }

        case IDENTIFICACION_OBSERVACION_LOADING:
            return {
                ... state,
                idLoading: true,
                identificacion: [],
                idLoaded:false,
                idError: '',
            }
        case IDENTIFICACION_OBSERVACION_LOADED:
            return {
                ...state,
                idLoading: false,
                identificacion: action.payload,
                idLoaded:true,
                idError: ''
            };
        case IDENTIFICACION_OBSERVACION_ERROR:
            return {
                ...state,
                idLoading: false,
                identificacion: [],
                idLoaded:false,
                idError: action.payload
            }

        case COMENTARIO_OBSERVACION_LOADING:
            return {
                ... state,
                comentarioLoading: true,
                comentario: [],
                comentarioLoaded:false,
                comentarioError: ''
            }
        case COMENTARIO_OBSERVACION_LOADED:
            return {
                ...state,
                comentarioLoading: false,
                comentario: action.payload,
                comentarioLoaded:true,
                comentarioError: ''
            };
        case COMENTARIO_OBSERVACION_ERROR:
            return {
                ...state,
                comentarioLoading: false,
                comentario: [],
                comentarioLoaded:false,
                comentarioError: action.payload
            }

        case OBSERVACION_INDIVIDUAL_EXPLORAR_LOADING:
            return {
                ... state,
                obsLoading: true,
                obs: [],
                obsLodaded:false,
                obsError: ''
            }
        case OBSERVACION_INDIVIDUAL_EXPLORAR_LOADED:
            return {
                ...state,
                obsLoading: false,
                obs: action.payload,
                obsLodaded:true,
                obsError: ''
            };
        case OBSERVACION_INDIVIDUAL_EXPLORAR_ERROR:
            return {
                ...state,
                obsLoading: false,
                obs: [],
                obsLodaded:false,
                obsError: action.payload
            }

        case OBSERVACION_EXPLORAR_LOADING:
            return {
                ... state,
                exploloading: true,
                explorar: [],
                exploloaded:false,
                exploerror: ''
            }
        case OBSERVACION_EXPLORAR_LOADED:
            return {
                ...state,
                exploloading: false,
                explorar: action.payload,
                exploloaded:true,
                exploerror: ''
            };

        case OBSERVACION_EXPLORAR_MAPA_LOADED:
            return {
                ...state,
                exploloading: false,
                explorarmapa: action.payload,
                exploloaded:true,
                exploerror: ''
            };
        case OBSERVACION_EXPLORAR_ERROR:
            return {
                ...state,
                exploloading: false,
                explorar: [],
                exploloaded:false,
                exploerror: action.payload
            }

        case OBSERVACION_HOME_LOADING:
            return {
                ... state,
                loading2: true,
                carusel: [],
                error2: ''
            }
        case OBSERVACION_HOME_LOADED:
            return {
                ...state,
                loading2: false,
                carusel: action.payload,
                error2: ''
            };
        case OBSERVACION_HOME_ERROR:
            return {
                ...state,
                loading2: false,
                carusel: [],
                error2: action.payload
            }

        case OBSERVACION_HOMEMAPA_LOADING:
            return {
                ... state,
                loading: true,
                puntos: [],
                error: ''
            }
        case OBSERVACION_HOMEMAPA_LOADED:
            return {
                ...state,
                loading: false,
                puntos: action.payload,
                error: ''
            };
        case OBSERVACION_HOMEMAPA_ERROR:
            return {
                ...state,
                loading: false,
                puntos: [],
                error: action.payload
            }

        case OBSERVACION_USER_LOADING:
            return {
                ... state,
                isLoading: false,
                observacion_user: [],
                error: ''
            }
        case OBSERVACION_USER_LOADED:
            return {
                ...state,
                isLoading: false,
                observacion_user: action.payload,
                isLoaded: true,
                error: ''
            };
        case OBSERVACION_USER_ERROR:
            return {
                ...state,
                isLoading: false,
                observacion_user: [],
                error: action.payload
            }
        default: return state;
    }
}